import React, { memo, useCallback } from 'react';
import { FlexView } from '@cuemath/comps';
import { Separator, Text } from '@cuemath/web-comps';
import COLORS from 'constants/colors';
import { DETECTION_TYPES_CONFIG } from 'constants/av-review';
import { VERDICT_STATES, VERDICT_DISPLAY } from '../../constants';
import {
  DetectionItemWrapper,
  ProgressBarWrapper,
  ProgressBarFill,
  LabelRow,
  ColorDot,
  VerdictLabelWrapper,
} from './detection-item-styled';

const DetectionItem = ({ detection, isActive, onSelect }) => {
  const { type, progress, verdict } = detection;
  const typeConfig = DETECTION_TYPES_CONFIG[type] || {};
  const { label } = typeConfig;
  const { reviewed, total } = progress;
  const percent = total > 0 ? Math.round((reviewed / total) * 100) : 0;
  const verdictConfig = VERDICT_DISPLAY[verdict] || VERDICT_DISPLAY[VERDICT_STATES.PENDING];

  const handleClick = useCallback(() => onSelect(type), [onSelect, type]);

  return (
    <DetectionItemWrapper isActive={isActive} onClick={handleClick}>
      <FlexView flexDirection="row" alignItems="center" justifyContent="space-between">
        <LabelRow>
          <ColorDot color={typeConfig.indicatorColor} />
          <Text variant="cta2" color={COLORS.BLACK}>{label}</Text>
        </LabelRow>
        <Text variant="cta2" color={COLORS.BLACK_T_60}>{reviewed}/{total}</Text>
      </FlexView>
      <Separator height={12} />
      <ProgressBarWrapper>
        <ProgressBarFill percent={percent} bgColor={typeConfig.bgColor} color={typeConfig.indicatorColor} />
      </ProgressBarWrapper>
      <Separator height={12} />
      <VerdictLabelWrapper bg={verdictConfig.bgColor} gap={2} gutter={12}>
        <Text variant="body3" color={verdictConfig.color}>
          {verdictConfig.icon && `${verdictConfig.icon} `}{verdictConfig.label}
        </Text>
      </VerdictLabelWrapper>
    </DetectionItemWrapper>
  );
};

export default memo(DetectionItem);
